import React, { useState } from 'react';
import NeonClock from './Clock/NeonClock';

import styles from './Clock/NeonClock.module.css';

const PredictionForm = ({ warDay, handleChange, handleSubmit, loading }) => (
  <form onSubmit={handleSubmit}>
    <label>
      Enter War Day:
      <input className='text-black' type="number" value={warDay} onChange={handleChange} min="1" max="10000" required />
    </label>
    <button type="submit" disabled={loading}>Predict</button>
  </form>
);

function GradioPage() {
  const [warDay, setWarDay] = useState(1);
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (event) => {
    setWarDay(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setPrediction(null);
    setError(null);

    try {
      const response = await fetch('https://yarsted16-ukraine-war-deathtoll.hf.space/predict', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ day: warDay })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail[0].msg);
      }

      const data = await response.json();
      setPrediction(data.prediction);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.body}>
      <div className='flex flex-col'>
        <div className='text-white absolute 
        top-0 mt-16 font-sen -translate-x-1/2 
        text-md text-justify overflow-hidden'>
          <PredictionForm warDay={warDay} 
          handleChange={handleChange} handleSubmit={handleSubmit} loading={loading} />
          {loading && <p>Loading...</p>}
          {error && <p className='text-red-700'>{error}</p>}
        </div>
        <div className={styles.wrapper}>
          <NeonClock value={prediction} />
        </div>
      </div>
    </div>
  );
}

export default GradioPage;
